import React, {useState, useEffect, Fragment} from 'react';
import axios from 'axios';
import {getMaps} from "../services/strapi";
import {STRAPI_MAPS_ONE, STRAPI_ROOT} from "../services/strapi";
import SharedGallery, {iGalleryItem} from "../shared/SharedGallery";


export interface iMapSummary {
    title: string;
    description: string;
    createdAt: Date;
    updatedAt: Date;
    featured: boolean;
    url: string;
    thumbnailUrl: string;
}

function MapGrid(props: iMapSummary) {

    return <div>
        <a href={`/maps/${props.url}`}><h4>{props.title}</h4></a>
        <p>{props.description}</p>

        {/*<img src={props.thumbnailUrl} className="img-fluid"/>*/}
        <a href={`/maps/${props.url}`} style={{display: 'block'}}>
            <img src={props.thumbnailUrl} alt={props.title + 'thumbnail'} className="img-fluid"/>
        </a>
        {/*<span style={{display: 'block'}}>{"Created: " + props.createdAt.toLocaleDateString() +*/}
        {/*    " " + props.createdAt.toLocaleTimeString()}</span>*/}
        {/*<span style={{display: 'block'}}>{"Updated: " + props.updatedAt.toLocaleDateString() +*/}
        {/*    " " + props.updatedAt.toLocaleTimeString()}</span>*/}
    </div>
}


export function MapPage(props: { onlyFeatured?: boolean, countLimit?: number, galleryHeight?: number }) {


    // return <div className="row px-lg-5 ms-lg-3 px-sm-4" style={{backgroundColor: 'yellowgreen'}}>
    // return <div className="" style={{backgroundColor: 'yellowgreen'}}>
    //     <h4>Maps</h4>
    // </div>
    const [maps, setMaps] = useState<iMapSummary[]>([]);
    const onlyFeatured = props.onlyFeatured || false;

    const galleryHeight = props.galleryHeight || 300;

    useEffect(() => {

        getMaps(onlyFeatured, props.countLimit || 0).then((maps) => {
            setMaps(maps);
        }).catch((e) => {
            console.log(e);
        })
    }, [])

    const mapGrids: iGalleryItem[] = [];

    for (let m of maps) {
        mapGrids.push({
            key: m.url,
            content: <MapGrid {...m}/>
        })
    }



    return <div className="row justify-content-center">
        <div className="col-sm-12 col-lg-10">
            <SharedGallery
                items={mapGrids}
                maxVisibleCount={3}
                itemHeight={`${galleryHeight}px`}
                useBootstrapGrid={!onlyFeatured}
            />
        </div>
    </div>

}


export function MapOne(props: { url: string }) {

    useEffect(() => {


        let reqUrl = STRAPI_MAPS_ONE(props.url)

        axios.get(reqUrl).then((d) => {
            const mapAttr = d['data']['data'][0]['attributes'];

            (document.getElementsByTagName('title')[0] as HTMLTitleElement).text = mapAttr['title'];

            const jsUrl = mapAttr['code']['js']['data']['attributes']['url'];
            const cssUrl = mapAttr['code']['css']['data']['attributes']['url'];

            const linkEL: HTMLLinkElement = document.createElement('link');
            linkEL.rel = 'stylesheet';
            linkEL.href = STRAPI_ROOT + cssUrl;
            (document.getElementsByTagName('head')[0] as HTMLBodyElement).appendChild(linkEL);

            const scriptEL: HTMLScriptElement = document.createElement('script');
            scriptEL.src = STRAPI_ROOT + jsUrl;
            (document.getElementsByTagName('body')[0] as HTMLBodyElement).appendChild(scriptEL);
        });
    }, []);

    return <>
    </>
}
